/**
 * Main JavaScript File
 */
import $ from 'jquery';


// Template Parts
import { header } from './template-parts/header/header'

// ACF Blocks
import { initTestimonialsSlider } from './template-parts/blocks/testimonials-slider'
import { initIconCardsCarousel } from './template-parts/blocks/icon-cards-carousel'
import { initLogosSlider } from './template-parts/blocks/logos-slider'
import { initImagesSlider } from './template-parts/blocks/images-slider'
import { initFAQ } from './template-parts/blocks/faq'

import { videoBlock, videoBlockPopup , videoPopup , imagePopup } from './template-parts/blocks/video'
import { counterNumbers } from './template-parts/blocks/counter-numbers'
import { initPricingPlans } from './template-parts/blocks/pricing-plans'

// Components
import { appearence } from './components/animations/appearence'
import { popup } from './components/popup'
import { filters } from './components/filters'

// Utils
import { initContentBlock } from './utils/content-block'

// Components
appearence()

// Template Parts
header()

// ACF Blocks
initTestimonialsSlider()
initLogosSlider()
initFAQ()
videoBlock()
videoBlockPopup()
imagePopup()
counterNumbers()
initIconCardsCarousel()
initPricingPlans()
//blogLoadMore()
initImagesSlider()
filters()
initContentBlock()

// Components
popup()

$(document).ready(function () {
    videoPopup()
    $('.content-block').find('table').wrap('<div class="table-wrapper"></div>');
    $('.content-block').find('iframe').wrap('<div class="iframe-wrapper"></div>');
})